import React from 'react';
import {
  isColorAttributeName,
  isValidColorValue,
  parseColorValueToCss,
} from '../../utils/colorUtils';

const ColorValueField = ({ value, onChange, disabled = false }) => {
  const trimmed = String(value || '').trim();
  const cssColor = parseColorValueToCss(trimmed);
  const pickerValue =
    cssColor && /^#[0-9a-f]{6}$/i.test(cssColor)
      ? cssColor
      : '#CCCCCC';

  const handlePickerChange = (e) => {
    onChange(e.target.value.toUpperCase());
  };

  const handleTextChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <div>
      <div className="d-flex align-items-center gap-3 mb-2">
        <input
          type="color"
          value={pickerValue}
          onChange={handlePickerChange}
          disabled={disabled}
          style={{ width: 56, height: 40, padding: 2, border: '1px solid #ced4da', borderRadius: 6 }}
          aria-label="Pick color"
        />
        <span
          style={{
            width: 40,
            height: 40,
            borderRadius: '50%',
            border: '1px solid #dee2e6',
            backgroundColor: cssColor || '#ffffff',
            flexShrink: 0,
          }}
          aria-hidden="true"
        />
        <input
          className="form-control"
          value={value}
          onChange={handleTextChange}
          disabled={disabled}
          placeholder="Enter color code"
        />
      </div>
      <small className="text-muted">
        Enter a hex code (e.g. #FF0000) or a color name. This swatch will show on the storefront.
      </small>
      {trimmed && !isValidColorValue(trimmed) ? (
        <div className="text-danger mt-1" style={{ fontSize: '0.8rem' }}>
          Enter a valid color value.
        </div>
      ) : null}
    </div>
  );
};

export const getSelectedAttributeName = (attributes, attributeId) => {
  const match = attributes.find(
    (item) => String(item.ProductAttributeId) === String(attributeId)
  );
  return match?.AttributeName || '';
};

export const isSelectedColorAttribute = (attributes, attributeId) =>
  isColorAttributeName(getSelectedAttributeName(attributes, attributeId));

export default ColorValueField;
